<template>
  <chat-layout @startNewChat="startNewChat" :slug="slug"/>
</template>

<script>
import ChatLayout from "../Layout/ChatLayout1/ChatLayout";
import {mapGetters} from "vuex";

export default {
  name: "SingleChat1",
  components: {ChatLayout},
  data() {
    return {
      slug: null,
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "User/isAuthenticated"
    })
  },
  methods: {
    startNewChat(res) {
      res = res.data.data
      const chatToken = res.chat_token;
      const slug = res.data.slug;
      localStorage.setItem('chat_token', chatToken)
      localStorage.setItem('chat_slug', slug)
      this.slug = slug
    },
    setSlugFromRouter() {
      const routerSlug = process.env.NODE_ENV == 'development' ? '8m0r6i6l8c6n' : this.$route.params.slug
      if (routerSlug !== undefined) {
        this.slug = routerSlug
      }
    },
    checkUserHaveTokenOrAuthenticated() {
      let chatToken = localStorage.getItem('chat_token')
      if (this.isAuthenticated || (chatToken != null)) {
        return true
      }

      return false

    }
  },
  mounted() {
    if (this.checkUserHaveTokenOrAuthenticated()) {
      this.setSlugFromRouter()
    } else {
      this.$router.push({name: "Login"})
    }

  }
}
</script>

<style scoped>
</style>